import {toast} from "sonner";

/**
 * `토스트 `알림
 * */

const handleActiveToast = ({message, description, labelListener}) => toast(message, {
    description,
    action: {
        label: "닫기",
        onClick: labelListener ? labelListener : () => {},
    },
});

const handleActiveError = ({message, description, labelListener}) => toast.error(message, {
    description,
    style: {background: "#fee2e2", color: "#991b1b", border: "1px solid #fecaca"},
    action: {
        label: "닫기",
        onClick: labelListener ? labelListener : () => {},
    },
});

export {handleActiveToast, handleActiveError};